<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title">资料附件上传</h1>
      <div class="personal-center-form__main">
        <div class="personal-center-form__file-list file-list" v-for="(item, index) in fileTypeList" @mouseenter="changeFileTye(item.fileId)">
          <h6 class="file-list__item-title">
            <span>{{`${item.fileName}${item.customerFileIsMustUpload === '1' ? '（必传）' : ''}`}}</span>
          </h6>
          <div class="file-list__item-content">
            <ul class="file-list__item-list">
              <template v-for="file in fileList[index].files">
                <li v-if="['pdf', 'rar', 'zip', '7z', 'PFD', 'RAR', 'ZIP', '7Z'].indexOf(getFileNameSuffix(file.fileName)) !== -1"
                  :class="['file-list__item-preview', `file-list__${getFileNameSuffix(file.fileName)}-preview`]"
                  @click.self="showPreviewImage(file.fileId, false)">
                  <div class="file-list__item-delete" @click.stop="deleteUploadedFile(item.fileId, file)"
                       v-if="!file.hasSaved">
                    <i class="el-icon-close"></i>
                  </div>
                  <div class="file-list__file-name">{{file.fileName}}</div>
                </li>
                <li v-else class="file-list__item-preview">
                  <img v-if="file.base64URL" :src="file.base64URL" @click="showPreviewImage(file.base64URL, true, true)">
                  <img v-else :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${userInfo.token}`" @click="showPreviewImage(file.fileId, true)">
                  <div v-if="!file.hasSaved" class="file-list__item-delete"
                       @click.stop="deleteUploadedFile(item.fileId, file)"><i class="el-icon-close"></i></div>
                </li>
              </template>
              <li v-if="!isIE9" slot="trigger" class="file-list__select-file">
                <el-upload :action="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`"
                           :data="{fileTypeId: item.fileId}"
                           :multiple="true" :accept="acceptFileTypes.join(',')" :headers="{tokenId: userInfo.token}"
                           :show-file-list="false" :auto-upload="true" :before-upload="verifyFile"
                           :on-success="uploadDone" :on-error="uploadFail" @click.native="test()">
                  <i class="el-icon-plus"></i>
                  <div class="file-list__select-file-title">{{item.fileName}}</div>
                </el-upload>
              </li>
              <!--element-ui上传控件不支持IE9，使用webuploader插件替代-->
              <li v-else class="file-list__select-file picker">
                <i class="el-icon-plus"></i>
                <div class="file-list__select-file-title">{{item.fileName}}</div>
              </li>

            </ul>
          </div>
        </div>
        <div class="text-center">
          <el-button type="primary" :loading="isSaving" class="personal-center-form__submit" @click="saveUploadedFile">提交</el-button>
        </div>
      </div>
    </div>
    <el-dialog class="file-preview-modal" title="图片预览" :visible="filePreview.show" :before-close="hidePreviewImage"
               :close-on-click-modal="false">
      <div class="file-preview-modal__body">
        <img :src="filePreview.src" alt="图片预览">
      </div>
      <div slot="footer" class="dialog__footer">
        <button class="dialog__footer__confirm-btn" @click="hidePreviewImage">确定</button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'
  import 'webuploader/css/webuploader.css'
  import jq from 'jquery'
  import Webuploader from 'webuploader'

  export default {
    data () {
      return {
        isAccord: false,
        uploader: '',
        fileTypeId: '',
        isIE9: true,
//        isIE9: navigator.userAgent.indexOf('MSIE 9.0') > -1,
        isSaving: false,
        filePreview: {
          show: false,
          src: ''
        },
        acceptFileTypes: [
          'image/jpg',
          'image/jpeg',
          'image/gif',
          'image/bmp',
          'image/png',
          'application/pdf',
          'application/x-rar-compressed',
          'application/x-zip-compressed',
          'application/zip',
          'application/x-7z-compressed'
        ]
      }
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
        userInfo: types.GET_USER,
        fileTypeList: types.GET_UPLOAD_FILE_TYPE_DATA,
        fileList: types.GET_UPLOAD_FILE_DATA
      })
    },
    methods: {
      ...mapActions({
        getFileList: types.SET_UPLOAD_FILE_DATA,
        saveFile: types.SAVE_UPLOADED_FILE,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      ...mapMutations({
        saveCurrentUploadFiles: types.SAVE_CURRENT_UPLOAD_FILE,
        deleteFile: types.DELETE_UPLOADED_FILE
      }),
      test () {
        document.getElementsByClassName('el-upload__input').value = null
      },
      verifyFile (file) {
        if (this.acceptFileTypes.indexOf(file.type) === -1) {
          this.setFailMessage({
            show: true,
            content: '请上传后缀为.jpg，.gif，.bmp，.gif，.pdf，.rar，.zip，.7z的文件'
          })
          return false
        }
        if (file.size > 1024 * 1024 * 10) {
          this.setFailMessage({
            show: true,
            content: '请上传大小不超过10M的文件'
          })
          return false
        }
        // 去重
        if (this.isIE9) {
          const flag = _.findIndex(this.uploader.getFiles(), item => item.name === file.name)
          if (flag !== -1) {
            this.setFailMessage({
              show: true,
              content: '该文件您已经上传过了，请不要上传重复的图片！'
            })
            return false
          }
        }
        return true
      },
      getFileNameSuffix (fileName) {
        const arr = fileName.split('.')
        return arr[arr.length - 1]
      },
      calculateFileSize (bytes) {
        if (bytes > 1024 * 1024) {
          return `${(bytes / (1024 * 1024)).toFixed(2)}MB`
        } else if (bytes > 1024) {
          return `${(bytes / 1024).toFixed(2)}KB`
        } else {
          return `${bytes}B`
        }
      },
      uploadFail (args) {},
      deleteUploadedFile (typeId, file) {
        if (this.isIE9) this.uploader.removeFile(file.fileId)
        this.deleteFile({
          typeId,
          file
        })
      },
      showPreviewImage (fileId, isImage, isBase64URL) {
        const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`
        if (isImage) {
          this.filePreview = {
            show: true,
            src: isBase64URL ? fileId : src
          }
        } else {
          window.open(`${location.origin}${src}`)
        }
      },
      hidePreviewImage () {
        this.filePreview.show = false
      },
      saveUploadedFile () {
        // 必传的检查目前交给后台完成
        this.saveFile({
          router: this.$router,
          token: this.userInfo.token,
          files: this.fileList
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            this.setSuccessMessage({
              show: true,
//              content: res.data.result
              content: '保存成功'
            })
          }
        })
      },
      uploadDone (file, res) { // IE9调用此方法
        const arr = res.split(':')
        this.saveCurrentUploadFiles({
          typeId: Number(arr[2].replace('fileTypeId=', '')),
          file: {
            fileId: arr[0].replace('sysFile=', ''),
            date: moment(file.lastModified).format('YYYY-MM-DD hh:mm'),
            fileName: file.name,
            size: this.calculateFileSize(file.size),
            hasSaved: false,
            base64URL: this.isIE9 ? file.base64URL : undefined  // 用于预览
          }
        })
      },
      changeFileTye (fileTypeId) {
        this.fileTypeId = fileTypeId
      },
      createWebUploader () {
        // 如果是ie9改用webuploader插件上传
        if (this.isIE9) {
          const timer = setInterval(() => {
            if (this.uploader) clearInterval(timer)
            this.uploader = Webuploader.create({
              auto: true, // 自动上传
              swf: './static/Uploader.swf',
              server: `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`,
              pick: {
                id: '.picker',
                multiple: true
              },
              resize: false,
              duplicate: false // 去重
            })
            this.uploader.on('beforeFileQueued', (file) => {
              this.isAccord = this.verifyFile(file)
            })
            this.uploader.on('fileQueued', (file) => {
              jq('#picker')
              this.uploader.makeThumb(file, (e, src) => {
                if (file.type.indexOf('image') !== -1) file.base64URL = src
              }, 363, 231)
            })
            this.uploader.on('uploadBeforeSend', (obj, data) => {
              data.fileTypeId = this.fileTypeId
              data.tokenId = this.userInfo.token
            })
            this.uploader.on('uploadSuccess', (file, res) => {
              if (this.isAccord) this.uploadDone(file, res)
            })
          }, 300)
        }
      }
    },
    mounted () {
      this.getFileList({
        router: this.$router,
        token: this.userInfo.token
      })
      // 如果是ie9改用webuploader插件上传
      this.createWebUploader()
    }
  }
</script>
<style lang="scss">
  @import "../../styles/fileUpload";

  $fileListBlue: #00c0ff;

  .personal-center-form__file-list {

    .file-list__item-title {
      color: $fileListBlue;

      span:before {
        background: $fileListBlue;
      }
    }

    .file-list__item-preview {
      position: relative;
      border: 1px dashed $fileListBlue;

      img {
        width: 100%;
        height: 100%;
      }

      .file-list__item-delete {
        /*width:100%;*/
        /*height:100%;*/
        background-color: $fileListBlue;
        position: absolute;
        left: 0;
        top: 0;
        /*z-index: -1;*/
      }

    }

  }

  .file-preview-modal {
    .dialog__footer__confirm-btn {
      background-color: $fileListBlue;
    }
  }

  .file-preview-modal__body {
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// FileUploading.vue?e8733b34